<template>
  <!-- Contact Us Form Section Start -->
  <div class="contact-form-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="contact-us-box">
            <div class="google-map-iframe">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121430.51861431437!2d-93.03563334080638!3d17.992516841455206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85edd796d7420653%3A0xf5607b62558ae894!2sVillahermosa%2C%20Tab.!5e0!3m2!1ses-419!2smx!4v1760656208118!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

            <div class="contact-us-form">
              <div class="section-title">
                <h2 class="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Envíanos un mensaje</h2>
                <p class="wow fadeInUp" data-wow-delay="0.4s">En MAP Tecnología y Seguridad estamos listos para ayudarte a proteger lo que más valoras...</p>
              </div>

              <form @submit.prevent="enviar" class="contact-form wow fadeInUp" data-wow-delay="0.6s">
                <div class="row">
                  <div class="form-group col-md-6 mb-4">
                    <input type="text" v-model="nombre" class="form-control" placeholder="Nombres" required>
                  </div>

                  <div class="form-group col-md-6 mb-4">
                    <input type="text" v-model="apellido" class="form-control" placeholder="Apellidos" required>
                  </div>

                  <div class="form-group col-md-6 mb-4">
                    <input type="email" v-model="email" class="form-control" placeholder="E-mail" required>
                  </div>

                  <div class="form-group col-md-6 mb-4">
                    <input type="text" v-model="telefono" class="form-control" placeholder="Número de celular" required>
                  </div>

                  <div class="form-group col-md-12 mb-5">
                    <textarea v-model="mensaje" class="form-control" rows="2" placeholder="Mensaje" required></textarea>
                  </div>

                  <div class="col-md-12">
                    <button type="submit" class="btn-default"><span>Enviar mensaje</span></button>
                  </div>
                </div>
              </form>

              <div v-if="estado" class="mt-3">
                <p :class="{'text-success': exito, 'text-danger': !exito}">{{ estado }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Contact Us Form Section End -->
</template>

<script>
import emailjs from "@emailjs/browser";

export default {
  data() {
    return {
      nombre: "",
      apellido: "",
      email: "",
      telefono: "",
      mensaje: "",
      estado: "", // mensaje de feedback
      exito: true // si fue éxito o error
    };
  },
  methods: {
    async enviar() {
      try {
        await emailjs.send(
          "service_jiq5vg9",   // reemplaza con tu Service ID
          "template_iww44ti",  // reemplaza con tu Template ID
          {
            nombre: this.nombre,
            apellido: this.apellido,
            email: this.email,
            telefono: this.telefono,
            mensaje: this.mensaje,
            fecha: new Date().toLocaleString()
          },
          "tIQPojUVpnHQfxfIt" // reemplaza con tu User/Public Key
        );
        this.estado = "¡Mensaje enviado correctamente!";
        this.exito = true;
        // limpiar campos
        this.nombre = "";
        this.apellido = "";
        this.email = "";
        this.telefono = "";
        this.mensaje = "";
      } catch (error) {
        console.error(error);
        this.estado = "Error al enviar el mensaje. Intenta nuevamente.";
        this.exito = false;
      }
    }
  }
};
</script>
